import qs from 'qs'

import api from '@/services/base.service'

const methods = {
  getSesion(usuario, bodegaId = '') {
    return api.get(`/cuentas/sesion/${usuario}`, {
      params: { bodegaId },
      paramsSerializer: (params) => qs.stringify(params)
    })
  }
}

export default methods
